export default __webpack_public_path__ + "static/media/RubyOnRails.c8243e92.png";